import StarIcon from '@material-ui/icons/Star'
import { capitalize } from 'lodash'
import React from 'react'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Pill } from '../../../components/Pill/Pill'
import { DriverStatus, User } from '../../../models/user'
import { error, errorD1, information, marigoldOrange, royalBlue, warning } from '../../../theme/colors'

interface ProfileHeaderDriverStatusProps {
  user: User
}

export function ProfileHeaderDriverStatus({ user }: ProfileHeaderDriverStatusProps) {
  const isEarlyDriver = user.driver?.isEarlyCycleDriver
  const [background, color] = getStatusColors(user.driver.status)

  return (
    <FlexBox gap="10px">
      <Pill background={background} color={color} variant="large">
        <FlexBox justifyContent="space-between" alignItems="center" gap="4px">
          {isEarlyDriver && <StarIcon fontSize="small" style={{ marginTop: -4 }} />}
          {capitalize(user.defaultTeamMembership?.driverStatus?.replace('_', ' ').toLocaleLowerCase())}
        </FlexBox>
      </Pill>
    </FlexBox>
  )
}

function getStatusColors(status?: DriverStatus) {
  if (!status) return [error, errorD1]

  if ([DriverStatus.ACTIVE].includes(status)) {
    return [information, royalBlue]
  }

  if ([DriverStatus.APPLYING, DriverStatus.ELIGIBLE, DriverStatus.ONBOARDING].includes(status)) {
    return [warning, marigoldOrange]
  }

  return [error, errorD1]
}
